/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

class TermsOfService extends React.Component
{

  render()
  {
    return(
      <div>
        <p>
          PLEASE READ THIS AGREEMENT CAREFULLY.  THIS ASTERIONDB INC. EVALUATION
          AGREEMENT (“AGREEMENT”) SETS FORTH THE LEGAL TERMS AND CONDITIONS
          WHICH GOVERN THE RELATIONSHIP BETWEEN YOU (“CUSTOMER” OR “YOU”)
          AND ASTERIONDB, INC. (THE “COMPANY”) AND THE RELATED TERMS AND
          CONDITIONS APPLICABLE TO ANY COMPANY PRODUCT YOU DOWNLOAD OR ACCESS. 
          YOU ACKNOWLEDGE THAT YOU ARE AUTHORIZED TO ACCEPT AND AGREE TO THE
          TERMS OF THIS AGREEMENT, AND THAT YOU INTEND TO ENTER INTO AND TO BE
          BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT ACCEPT THE TERMS
          OF THIS AGREEMENT, YOU MAY NOT USE THE SOFTWARE.  BY ACCEPTING, YOU
          WILL BE GRANTED ACCESS TO THE PRODUCT, AND THIS AGREEMENT WILL BE
          EFFECTIVE IMMEDIATELY (THE “EFFECTIVE DATE”).
        </p>
        <p><b>1. Grant of Rights; Restrictions; Feedback</b></p>
        <p >
          <u>a. Grant of Rights.</u>
          <br/>
          Subject to the terms and conditions of this Agreement and for the
          duration of the license term, the Company hereby grants to Customer a
          nonexclusive, nontransferable license, without the right of
          sublicense, to: (i) access and use the Software; and (ii) copy and
          use the documentation, training materials or other materials supplied
          by the Company to enable such use, in each case solely for evaluation
          purposes, and pursuant to the restrictions set forth in this
          Agreement.   
        </p>
        <p>
          <u>b. Restrictions.</u>
          <br/>
          Customer shall not: (i) distribute, sell, lend, rent, lease,
          transfer, or grant any rights in or to all or any portion of the
          Software or documentation; (ii) copy the Software, in whole or in
          part; (iii) remove or alter any trademark, logo, copyright or other
          proprietary notices, legends, symbols or labels in the Software or
          documentation; (iv) except as expressly provided for in this
          Agreement, use the Software in connection with any deployed computer
          system, including without limitation commercial, for-profit, or
          publicly accessible system or for commercial or revenue generating
          purposes; (v) permit third parties to use the Software or
          documentation, or develop or deploy any system or software including
          the Software for use by any third parties; (vi) reverse assemble,
          reverse compile, decompile, translate or otherwise attempt to
          discover the source code of any component of the Software; (vii)
          reproduce, prepare derivative works of, display, perform, rent,
          lease, sell, license, sublicense, assign, distribute or otherwise
          transfer the Software or documentation or any components thereof; or
          (viii) access or use the Software or documentation in order to build
          a competitive product or service.
        </p>
        <p>
          <u>c. Feedback.</u>
          <br/>
          Customer will use reasonable efforts to report to the Company any
          “bugs” or reproducible errors in the Software as they are
          encountered. Customer agrees that any information or feedback
          Customer may provide to Company related to the Software or this
          Agreement is non-confidential and Customer grants Company a
          non-exclusive, worldwide, fully paid up, perpetual and irrevocable
          license to use this information/feedback in Company’s business
          activities without restriction and without payment or accounting to
          Customer or any third party.  The Company retains all right, title
          and interest in and to any work product created by the Company in the
          course of providing the Software and any service or support under
          this Agreement.
        </p>
        <p><b>2. Intellectual Property Ownership.</b></p>
        <p>
          The Software and the documentation are the intellectual property of the
          Company.  This includes, but is not limited to, patents, trademarks,
          trade secret rights, inventions, copyrights, know how and trade
          secrets.   The Software is protected by law, including but not
          limited to the trade secret laws, trademark laws, patent laws and the
          copyright laws of the United States and other countries, and by
          international treaty provisions.  Except as expressly stated herein,
          this agreement does not grant Customer any intellectual property
          rights in the Software or documentation.  All rights not expressly
          granted are reserved by the Company.
        </p>
        <p><b>3. No Indemnities; No Warranties.</b></p>
        <p>
          THIS AGREEMENT DOES NOT ENTITLE CUSTOMER TO ANY INDEMNIFICATION OF
          ANY KIND. THE SOFTWARE AND DOCUMENTATION ARE LICENSED &quot;AS IS.&quot;
          THE COMPANY MAKES NO WARRANTIES, EXPRESS, IMPLIED, STATUTORY OR
          OTHERWISE WITH RESPECT TO THE SOFTWARE AND DOCUMENTATION, AND
          EXPRESSLY DISCLAIMS ALL IMPLIED WARRANTIES INCLUDING BUT NOT LIMITED
          TO WARRANTIES OF NONINFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A
          PARTICULAR PURPOSE. THE COMPANY DOES NOT WARRANT THAT THE SOFTWARE
          WILL BE UNINTERRUPTED OR ERROR-FREE, OR SUCCEED IN RESOLVING ANY
          PROBLEM. CUSTOMER AGREES THAT USE OF THE SOFTWARE IS AT CUSTOMER’S
          OWN RISK. CUSTOMER HAS NO WARRANTY OR GUARANTEE UNDER THIS AGREEMENT
          THAT THE OPERABILITY OF ANY OF CUSTOMER’S APPLICATIONS RUNNING WITH
          THE SOFTWARE WILL BE MAINTAINED WITH ANY SUBSEQUENT OR GENERALLY
          AVAILABLE VERSIONS OF THE SOFTWARE OR THAT ANY VERSION OF THE
          SOFTWARE WILL EVER BE MADE AVAILABLE OR MARKETED. EXCEPT AS MAY
          OTHERWISE EXPRESSLY PROVIDED FOR HEREIN, NEITHER THIS AGREEMENT NOR
          CUSTOMER’S ACCESS TO THE SOFTWARE ENTITLE CUSTOMER TO RECEIVE
          SUPPORT SERVICES FROM THE COMPANY FOR THE SOFTWARE.
        </p>
        <p><b>4. Limitation of Liability.</b></p>
        <p>
          TO THE EXTENT NOT PROHIBITED BY LAW, IN NO EVENT SHALL THE COMPANY BE
          LIABLE FOR ANY DIRECT OR INDIRECT DAMAGES, INCLUDING INTERRUPTION OF
          USE OR LOSS OR CORRUPTION OF DATA, LOST REVENUE OR PROFITS, COST OF
          COVER OR OTHER SPECIAL, INCIDENTAL, CONSEQUENTIAL, DIRECT, INDIRECT,
          OR PUNITIVE DAMAGES OR CLAIMS FROM A 3RD
          PARTY ARISING FROM THE USE OF THE SOFTWARE, HOWEVER CAUSED AND
          REGARDLESS OF THE THEORY OF LIABILITY. IN NO EVENT SHALL THE
          COMPANY’S LIABILITY, WHETHER BASED IN CONTRACT, TORT (INCLUDING
          NEGLIGENCE) OR OTHERWISE, EXCEED THE GREATER OF THE AMOUNT PAID FOR
          THE SOFTWARE UNDER THIS AGREEMENT OR FIFTY DOLLARS ($50.00). THE
          FOREGOING LIMITATIONS WILL APPLY EVEN IF COMPANY HAS BEEN ADVISED OF
          THE POSSIBILITY OF SUCH DAMAGES. THE PARTIES ACKNOWLEDGE THAT THIS IS
          A REASONABLE ALLOCATION OF RISK.
        </p>
        <p><b>5. Termination.</b></p>
        <p><u>a. Termination.</u></p>
        <p>
          Either party may terminate the Agreement at any time by giving the other party written notice of termination.
        </p>
        <p><u>b. Effect of Termination.</u></p>            
        <p>
          Upon termination or expiration of this Agreement, all licenses granted hereunder shall cease.
        </p>
        <p><u>c. Survival.</u></p>
        <p>
        The following sections shall survive any termination of this Agreement: 1(b), 1(c), 2, 3, 4, 5(b), 5(c), 7 and 8 all associated definitions.
        </p>
        <p><b>6. Relationship of the Parties.</b></p>
        <p>
          Nothing in this Agreement will be construed to create a partnership,
          joint venture or agency relationship between the parties. The parties
          agree that each is an independent contractor and neither party will
          have the power to bind the other or to incur obligations on the
          other’s behalf without such other party’s prior written consent.
          Nothing in this Agreement shall be construed as an obligation by
          either party to enter into a contract, subcontract, or other business
          relationship with the other party. Each party shall bear all costs
          and expenses incurred by it under or in connection with this
          Agreement.
        </p>
        <p><b>7. Export Regulations.</b></p>
        <p>
          The Software is regulated by the Department of Commerce and Export
          Administration Regulations (and may be subject to export or import
          regulations in other countries). Customer agrees not to transfer,
          export or re-export, directly or indirectly, the Software to any
          Prohibited Entity, and Customer affirms that Customer is not a
          Prohibited Entity or acting on behalf of any Prohibited Entity. A
          Prohibited Entity includes any person or entity who is a government
          end-user (as defined in part 772 of the U. S. Export Administration
          Regulations), a military end-user, or a resident of any country to
          which the Export Administration Regulations prohibit exportation of
          encrypted software. The Company’s obligations to provide the
          Software is subject in all respects to such United States laws and
          regulations as shall from time to time govern the license and
          delivery of technology and software abroad. Customer agrees to comply
          strictly with all such laws and regulations and hereby acknowledges
          that Customer has the responsibility to obtain such licenses to
          export, re-export, or import as may be required after delivery of the
          Software to Customer
        </p>
        <p><b>8. Miscellaneous.</b></p>
        <p>
          This Agreement is not assignable or transferable by Customer without
          the Company’s prior written consent. No failure or delay in
          exercising any right hereunder will operate as a waiver, thereof, nor
          will any partial exercise of any right or power hereunder preclude
          further exercise. If any provision of this Agreement is held to be
          unenforceable, this Agreement will remain in effect with the
          provision omitted, unless omission would frustrate the intent of the
          parties, in which case this Agreement will immediately terminate.
          This Agreement may be modified, replaced or rescinded only in writing
          and signed by a duly authorized representative of each party. This
          Agreement shall be construed under and governed by the laws of the
          State of Delaware, without regard to conflict of law provisions.
        </p>
        <p>
          THIS AGREEMENT SUPERSEDES ALL PRIOR OR CONTEMPORANEOUS ORAL OR WRITTEN
          COMMUNICATIONS, PROPOSALS, REPRESENTATIONS, UNDERTAKINGS AND
          WARRANTIES AND PREVAILS OVER ANY CONFLICTING OR ADDITIONAL TERMS OF
          ANY QUOTE, PURCHASE ORDER, ACKNOWLEDGMENT, OR OTHER COMMUNICATION
          BETWEEN THE PARTIES RELATING TO ITS SUBJECT MATTER DURING THE TERM OF
          THIS AGREEMENT.
        </p>
      </div>
    );
  }
}

export default TermsOfService
